import React, { useState } from "react";
import HorizontalTabs from "../../../Common/Horizontal-Tabs/HorizontalTabs";
import FinancialProfile from "./FinancialProfile";
import TaxConfiguration from "./TaxConfiguration";


const invoiceTabs = [
  { name: "Financial Profile" },
  { name: "Tax Configuration" },
];

function InvoiceConfiguration() {
  const [activeTab, setActiveTab] = useState(0);

  const renderTabContent = () => {
    const activeTabName = invoiceTabs[activeTab]?.name;

    const tabComponents = {
      "Financial Profile": <FinancialProfile />,
      "Tax Configuration": <TaxConfiguration />,
    };

    return (
      tabComponents[activeTabName] || (
        <div>No content available for this invoice configuration.</div>
      )
    );
  };

  return (
    <div>
      <div
        style={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div>
          <div
            style={{
              alignItems: "center",
              display: "flex",
              gap: "10px",
              marginBottom: "4px",
            }}
          >
            <h2 style={{ margin: 0 }}>Invoicing</h2>
          </div>
          <p
            style={{
              color: "var(--grid-na-text)",
              fontSize: "14px",
              margin: 0,
            }}
          >
            Manage your company details, tax configurations, and invoice
            defaults.
          </p>
        </div>
      </div>

      <div
        className="candidate-tabs-container"
        style={{
          marginLeft: "10px",
          marginBottom: "18px",
        }}
      >
        <HorizontalTabs
          activeTab={activeTab}
          handleTabChange={setActiveTab}
          tabNames={invoiceTabs}
          containerStyle={{ width: "100%" }}
          tabstyle={{
            borderRadius: "10px 10px 0 0",
            marginBottom: "10px",
          }}
          tabBorderBottom="0"
        />
      </div>

      {renderTabContent()}
    </div>
  );
}

export default InvoiceConfiguration;
